export class TradutorRQ {
    public Conteudo: string;
    public LinguaAlvo: string;
    public Tipo: string;
}

export class TradutorRS {
    public Conteudo: string;
    public Uso: Uso = new Uso();
    public Idioma: string;
}

export class Uso {
    public UsoEntrada: number;
    public UsoSaida: number;
}